import { 
  startOfMonth, 
  endOfMonth, 
  startOfWeek, 
  endOfWeek, 
  addDays,
  format 
} from 'date-fns';
import { nl } from 'date-fns/locale';
import { CalendarEvent } from '@/hooks/useOutlookCalendar';
import { CalendarDayCell } from './CalendarDayCell';

interface CalendarGridProps {
  currentDate: Date;
  events: CalendarEvent[];
  selectedDate: Date;
  onSelectDate: (date: Date) => void;
}

const WEEKDAYS = ['ma', 'di', 'wo', 'do', 'vr', 'za', 'zo'];

export function CalendarGrid({ 
  currentDate, 
  events, 
  selectedDate,
  onSelectDate 
}: CalendarGridProps) {
  // Generate calendar days (6 weeks to ensure full month coverage)
  const monthStart = startOfMonth(currentDate);
  const monthEnd = endOfMonth(currentDate);
  const calendarStart = startOfWeek(monthStart, { weekStartsOn: 1 }); // Monday
  const calendarEnd = endOfWeek(monthEnd, { weekStartsOn: 1 });

  const days: Date[] = [];
  let current = calendarStart;
  while (current <= calendarEnd) {
    days.push(current);
    current = addDays(current, 1);
  }

  return (
    <div className="bg-card rounded-xl border border-border overflow-hidden">
      {/* Weekday headers */}
      <div className="grid grid-cols-7 border-b border-border bg-muted/30">
        {WEEKDAYS.map((day) => (
          <div 
            key={day}
            className="py-3 text-center text-sm font-medium text-muted-foreground uppercase tracking-wider"
          >
            {day}
          </div>
        ))}
      </div>

      {/* Calendar grid */}
      <div className="grid grid-cols-7">
        {days.map((day, index) => (
          <CalendarDayCell
            key={day.toISOString()}
            day={day}
            currentMonth={currentDate}
            events={events}
            isSelected={day.toDateString() === selectedDate.toDateString()}
            onSelect={onSelectDate}
          />
        ))}
      </div>
    </div>
  );
}
